<template>
  <div class="roles">
    <div class="roles-title">
      请选择角色
      <div class="close icon-popup-close" @click="close"></div>
    </div>
    <div class="role-tabs">
      <readerTab
        :text="'全部'"
        :activeLable="activeReaderTab"
        @onClick="clickReaderTab"
      ></readerTab>
      <readerTab
        v-for="(item, i) in readerTabs"
        :key="i"
        :text="item.name"
        :activeLable="activeReaderTab"
        :item="item"
        @onClick="clickReaderTab"
      ></readerTab>
    </div>
    <div class="role-content">
      <role
        v-for="item, i in readerOpts"
        :key="i"
        :label="item.label"
        :value="item.value"
        :active="isReaderActive(item)"
        :item="item"
        :activeTab="activeReaderTab"
        @clickReader="onClickReader"
        :style="{marginBottom: i === readerOpts.length - 1 ? 12 + 'px' : ''}"
      ></role>
    </div>
  </div>
</template>

<script>
import ReaderTab from '@/components/subtitle/dialogs/smartVoice/readerTab';
import Role from '@/components/subtitle/dialogs/smartVoice/reader';
export default {
  components: {
    ReaderTab,
    Role
  },
  props: {
    readerOpts: {
      type: Array,
      default () {
        return []
      }
    },
    readerTabs: {},
    readerData: {}
  },
  data () {
    return {
      activeReaderTab: '',
      reader: '',
      readerId: ''
    }
  },
  mounted () {
    this.reader = this.readerData.value;
  },
  methods: {
    clickReaderTab (tab) {
      this.activeReaderTab = tab.value || '';
    },
    onClickReader (val) {
      this.reader = val.value;
      this.readerId = val.id;
      this.$emit('updateReader', val);
    },
    close () {
      this.$emit('close')
    },
    isReaderActive (item) {
      const readerId = this.readerData.id;
      return readerId ? item.id === readerId : (item.value || item.sourceId) === this.reader;
    }
  }
}
</script>

<style lang="scss" scoped>
.roles {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 244px;
  height: 413px;
  background: #f6f6fc;
  box-shadow: -4px 4px 6px rgba(150, 150, 150, 0.16);
}
.roles-title {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: #d9ddea;
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
  & .close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}
.role-tabs {
  width: 100%;
  height: 40px;
  display: flex;
  font-size: 12px;
}
.role-content {
  width: 100%;
  flex-grow: 1;
  height: 333px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dee9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dubbing/smartVoiceEdit/roles.vue